import React, { useContext } from 'react';
// import { Tooltip } from 'antd';
import Tooltip from '@material-ui/core/Tooltip';
import { useIntl } from 'umi';
import zhCN from '@/locales/zh-CN.ts';
import { ThemeContext } from 'styled-components';
import { makeStyles } from '@material-ui/styles';
import { BrandContext } from '@/contexts/ContextProviders';
import { TooltipsStyled } from './TooltipsStyled';
import IconButton from '@material-ui/core/IconButton';
// import tooltipIcon from '@/assets/icons/tooltipIcon.svg';
import SvgIconML from '@/components/SvgIconML/SvgIconML';

const useStyles = makeStyles({
  popper: {
    maxWidth: '264px',
    background: '#fff',
    border: '0.5px solid #9e9e9e',
    filter: 4,
    opacity: 0.92,
    borderRadius: 4,
    zIndex: 9999,
    // border: 0,
    // color: 'white',
    // height: 48,
    // padding: '0 30px',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  },
  tooltip: {
    background: '#fff',
    color: '#616161',
    fontSize: '12px',
    listStyle: 'none',
    // 文字12px，#616161，上下左右边距16
  },
  label: {
    textTransform: 'capitalize',
    padding: '8px',
  },
});

const Tooltips = ({ boxId, extra }) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const intl = useIntl();
  const { formatMessage } = intl;
  let descCount = 0; // 描述文字条数
  let msgArray = [];
  // const MyIcon = createFromIconfontCN({
  //   scriptUrl: '//at.alicdn.com/t/font_1304981_mi0so91akp.js', // 在 iconfont.cn 上生成
  // });

  const classes = useStyles();

  for (let index = 1; index < 20; index++) {
    // let liContent = <FormattedMessage id={boxId + '.desc_' + index} />;
    let indexStr = index < 10 ? '0' + index : String(index);
    let descId = boxId + '.desc' + indexStr;
    if (zhCN[descId]) {
      let liContent = zhCN[descId];
      if (extra && typeof liContent === 'string') {
        Object.keys(extra).forEach((k) => {
          liContent = liContent.replaceAll(`{${k}}`, extra[k]);
        });
      }
      // console.log(liContent, 'formatMessage');
      msgArray.push(
        <li style={{ margin: '8px 0' }} key={descId}>
          {liContent}
        </li>,
      );
      descCount++;
    }
  }
  // msg = msgArray.join("");
  // console.log(msg);

  return (
    <React.Fragment>
      {descCount > 0 && (
        <TooltipsStyled theme={themeContext} brand={brandContext}>
          <Tooltip
            // overlayClassName="tooptipMsgBox"
            placement="bottom"
            title={msgArray}
            // arrow
            // open={true}
            className={'icon_question'}
            classes={{ popper: classes.popper, tooltip: classes.tooltip }}
          >
            <IconButton className="icon-wrap" aria-label="delete">
              <SvgIconML name={'tooltipIcon'} size={16}></SvgIconML>
            </IconButton>
          </Tooltip>
        </TooltipsStyled>
      )}
    </React.Fragment>
  );
};

export default Tooltips;
